import {KnowledgeRAGResponse} from 'common/src/modules/ai/ai.types';
import tabularDataToCsv from 'common/src/modules/shared/copilot/csvUtils/tabularDataToCsv';
import formatDecimalAsPercentage from 'common/src/utils/numberUtils/formatDecimalAsPercentage';
import _isNil from 'lodash/isNil';

function formatFullAnswer(response: KnowledgeRAGResponse): string {
  const parts: string[] = [];

  if (response.answer) {
    parts.push(`Answer: ${response.answer}`);
  }

  if (!_isNil(response.confidence)) {
    parts.push(`\nConfidence: ${formatDecimalAsPercentage(response.confidence)}`);
  }

  if (response.resources && response.resources.length > 0) {
    parts.push('\n\nResources:');
    const csvResources = tabularDataToCsv(
      response.resources.map((resource) => ({
        title: resource.title,
        relevancyScore: formatDecimalAsPercentage(resource.relevancyScore),
      })),
    );

    parts.push(`\n${csvResources}`);
  }

  if (response.issues) {
    parts.push(`\n\nIssues: ${response.issues}`);
  }

  return parts.join('');
}

export default formatFullAnswer;
